import { retrieveMatterLawWorksCharges } from "@/lib/data/requests/matters/lawworks-charges";
import { queryKeys } from "@/lib/data/static/query-keys";

export const retrieveMatterLawWorksChargesQueryOptions = (
  data: Parameters<typeof retrieveMatterLawWorksCharges>[0],
) => ({
  queryKey: [
    queryKeys.matterLawWorksCharges,
    data.matterId,
    data.startDate,
    data.endDate,
    data.pageNumber ?? 1,
    data.pageSize ?? 25,
  ],
  enabled: Boolean(data.matterId),
  queryFn: () => retrieveMatterLawWorksCharges(data),
});
